// extracted by mini-css-extract-plugin
export default {"container":"dk_g","singleColumnContainer":"dk_lN","title":"dk_cX","description":"dk_c"};